import React from "react";
import ReactECharts from "echarts-for-react";

interface BillingSummaryReportLineChartProps {
  xAxisData?: string[];
  yAxisData?: number[];
  legend?: string;
}

const BillingSummaryReportLineChart: React.FC<
  BillingSummaryReportLineChartProps
> = ({
  xAxisData = [
    "01/05",
    "02/05",
    "03/05",
    "04/05",
    "05/05",
    "06/05",
    "07/05",
    "08/05",
    "09/05",
    "10/05",
  ],
  yAxisData = [20, 5, -5, 15, 10, 5, 10, 20, 10, 18],
  legend = "Amount",
}) => {
  const options = {
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        rotate: 45,
        formatter: (value: string) => {
          return value;
        },
      },
      axisLine: { show: false },
      axisTick: { show: false },
      interval: 0,
      // splitLine: {
      //   show: true,
      //   lineStyle: {
      //     color: "#ddd",
      //     type: "dashed",
      //   },
      // },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (value: number) => `${value}`,
        color: "#5F6368",
        fontSize: 9,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ddd",
          type: "dashed",
        },
      },
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      formatter: (params: any) => `
        <div style="padding: 5px; color: #fff;">
          ${params[0].name}: ${params[0].value}%
        </div>
      `,
    },
    grid: {
      left: "2%",
      right: "2%",
      bottom: "3%",
      containLabel: true,
    },
    legend: {
      data: [{ name: `${legend}`, icon: "roundRect" }],
      left: "12",
      top: "12",
      itemWidth: 15,
      itemHeight: 15,
      itemGap: 15,
      textStyle: {
        fontFamily: "Figtree",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11.72,
        letterSpacing: "0.02em",
        color: "#4C5269",
        textAlign: "left",
      },
      selectedMode: true,
    },
    series: [
      {
        name: `${legend}`,
        type: "bar",
        data: yAxisData,
        smooth: true,
        lineStyle: { width: 1, color: "#29CBFF" },
        itemStyle: { color: "#29CBFF" },
        symbol: "circle",
        symbolSize: 6,
        emphasis: {
          disabled: true,
        },
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "100%", width: "100%" }} />
  );
};

export default BillingSummaryReportLineChart;
